const ADMIN = 'admin'

export const LOCAL_STORAGE = {
  ADMIN,
}
